import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { DEFAULT_DRAG_STYLE } from '../../../DragDrop'
import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../../Icon'
import Text from '../../../Text'

import { getDraggableItemStyle } from './DocFlowEditSequenceModalDraggableItem.utils'

import * as styles from './DocFlowEditSequenceModalDraggableItem.module.css'

import DragDropIcon from '../../../../icons/drag-and-drop.svg'

function DocFlowEditSequenceModalDraggableItem({
  id,
  isLoading,
  name,
  position,
}) {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({
    data: {
      position,
    },
    disabled: isLoading,
    id: id.toString(),
  })

  const style = getDraggableItemStyle({
    isDragging,
    style: {
      ...DEFAULT_DRAG_STYLE,
      transform: CSS.Transform.toString(transform),
      transition,
    },
  })

  return (
    <div className={styles.drag} ref={setNodeRef} style={style}>
      <IconNG
        {...attributes}
        {...listeners}
        Icon={DragDropIcon}
        className={styles.dragIcon}
        color={ICON_COLOR.TextDisabledColor}
        size={ICON_HEIGHT_16}
      />
      <Text>{name}</Text>
    </div>
  )
}

export default DocFlowEditSequenceModalDraggableItem
